import React from "react";
import LogoMurphy from "components/header/assets/logo-murfy.svg";
import Container from "components/design-system/templates/Container";
import { styled } from "@material-ui/core/styles";
import LogOut from "components/design-system/molecules/LogOut";
import useHomeRepairAuth from "hooks/useHomeRepairAuth";
import { BoxProps, Box } from "@material-ui/core";

const HeaderContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: theme.spacing(10),
}));

const Logo = styled(LogoMurphy)(({ theme }) => ({
  fill: theme.palette.secondary.main,
}));

const HomeRepairManagementHeader: React.FunctionComponent<BoxProps> = ({ children, ...props }) => {
  const { authenticated } = useHomeRepairAuth();
  return (
    <Container variant="pink">
      <HeaderContainer {...props}>
        <a href="/">
          <Logo width="60px" height="60px" />
        </a>
        {authenticated && <LogOut />}
        {children}
      </HeaderContainer>
    </Container>
  );
};

export default HomeRepairManagementHeader;
